import classNames from 'classnames/bind';
import styles from './EmptyLayout.module.css';
const cx = classNames.bind(styles);

function EmptyLayout({ children }) {
  return (
    <div className={cx('wrapper')}>
      {children}
    </div>
  );
}

export default EmptyLayout;
